import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'page-not-permission',
  templateUrl: './page-not-permission.component.html',
  styleUrls: ['./page-not-permission.component.scss']
})
export class PageNotPermissionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
